import { EventBroker } from "../../../lib/utils/event-broker";

export const EVENTS = {
  INIT: 'INIT',
  SAVE: 'SAVE',
  UPDATE_AUTO_FONT_SIZE_VALUE: 'UPDATE_AUTO_FONT_SIZE_VALUE',
  ADD_ADDITIONAL_TABLE_FIELD: 'ADD_ADDITIONAL_TABLE_FIELD',
  CLOSE: 'CLOSE',
}

export const simpleTableBuilderEventBroker = window.eventBroker = new EventBroker();
